import noop from 'lodash/noop';

import { TestId, UncontrolledCheckbox } from '@dreryk/react-components';

type CheckboxCellProps = {
   readonly selected: boolean;
   readonly testId: TestId;
};

export const CheckboxCell = (props: CheckboxCellProps): JSX.Element => {
   return (
      <UncontrolledCheckbox
         onSelectionChange={noop}
         selected={props.selected}
         id={`${props.testId}`}
         name={`${props.testId}`}
         testId={props.testId}
         disabled
      />
   );
};
